import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserMutationVariables = Types.Exact<{
  input: Types.CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'RootMutationType', createUser: { __typename?: 'CreateUserResult', result?: { __typename?: 'User', id: string, username: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, code?: string | null, fields?: Array<string> | null }> } };

export type PerformSignupStepMutationVariables = Types.Exact<{
  input: Types.PerformSignupStepInput;
}>;


export type PerformSignupStepMutation = { __typename?: 'RootMutationType', performSignupStep: boolean };

export type CurrentUserPendingTasksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserPendingTasksQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, isTeacher?: boolean | null, signupPending?: Array<string> | null, signupComplete?: boolean | null, coppaApprovedAt?: any | null } | null };

export type SuggestUsernamesMutationVariables = Types.Exact<{
  input: Types.SuggestUsernamesInput;
}>;


export type SuggestUsernamesMutation = { __typename?: 'RootMutationType', suggestUsernames: Array<string> };

export type CheckUsernameAvailabilityMutationVariables = Types.Exact<{
  input: Types.CheckUsernameAvailabilityInput;
}>;


export type CheckUsernameAvailabilityMutation = { __typename?: 'RootMutationType', checkUsernameAvailability: { __typename?: 'UsernameAvailability', available: boolean, reason?: string | null } };


export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    result {
      id
      username
    }
    errors {
      message
      code
      fields
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const PerformSignupStepDocument = gql`
    mutation performSignupStep($input: PerformSignupStepInput!) {
  performSignupStep(input: $input)
}
    `;
export type PerformSignupStepMutationFn = Apollo.MutationFunction<PerformSignupStepMutation, PerformSignupStepMutationVariables>;

/**
 * __usePerformSignupStepMutation__
 *
 * To run a mutation, you first call `usePerformSignupStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformSignupStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performSignupStepMutation, { data, loading, error }] = usePerformSignupStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePerformSignupStepMutation(baseOptions?: Apollo.MutationHookOptions<PerformSignupStepMutation, PerformSignupStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformSignupStepMutation, PerformSignupStepMutationVariables>(PerformSignupStepDocument, options);
      }
export type PerformSignupStepMutationHookResult = ReturnType<typeof usePerformSignupStepMutation>;
export type PerformSignupStepMutationResult = Apollo.MutationResult<PerformSignupStepMutation>;
export type PerformSignupStepMutationOptions = Apollo.BaseMutationOptions<PerformSignupStepMutation, PerformSignupStepMutationVariables>;
export const CurrentUserPendingTasksDocument = gql`
    query currentUserPendingTasks {
  currentUser {
    id
    isTeacher
    signupPending
    signupComplete
    coppaApprovedAt
  }
}
    `;

/**
 * __useCurrentUserPendingTasksQuery__
 *
 * To run a query within a React component, call `useCurrentUserPendingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPendingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPendingTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPendingTasksQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>(CurrentUserPendingTasksDocument, options);
      }
export function useCurrentUserPendingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>(CurrentUserPendingTasksDocument, options);
        }
// @ts-ignore
export function useCurrentUserPendingTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>;
export function useCurrentUserPendingTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserPendingTasksQuery | undefined, CurrentUserPendingTasksQueryVariables>;
export function useCurrentUserPendingTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>(CurrentUserPendingTasksDocument, options);
        }
export type CurrentUserPendingTasksQueryHookResult = ReturnType<typeof useCurrentUserPendingTasksQuery>;
export type CurrentUserPendingTasksLazyQueryHookResult = ReturnType<typeof useCurrentUserPendingTasksLazyQuery>;
export type CurrentUserPendingTasksSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPendingTasksSuspenseQuery>;
export type CurrentUserPendingTasksQueryResult = Apollo.QueryResult<CurrentUserPendingTasksQuery, CurrentUserPendingTasksQueryVariables>;
export const SuggestUsernamesDocument = gql`
    mutation suggestUsernames($input: SuggestUsernamesInput!) {
  suggestUsernames(input: $input)
}
    `;
export type SuggestUsernamesMutationFn = Apollo.MutationFunction<SuggestUsernamesMutation, SuggestUsernamesMutationVariables>;

/**
 * __useSuggestUsernamesMutation__
 *
 * To run a mutation, you first call `useSuggestUsernamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestUsernamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestUsernamesMutation, { data, loading, error }] = useSuggestUsernamesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestUsernamesMutation(baseOptions?: Apollo.MutationHookOptions<SuggestUsernamesMutation, SuggestUsernamesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestUsernamesMutation, SuggestUsernamesMutationVariables>(SuggestUsernamesDocument, options);
      }
export type SuggestUsernamesMutationHookResult = ReturnType<typeof useSuggestUsernamesMutation>;
export type SuggestUsernamesMutationResult = Apollo.MutationResult<SuggestUsernamesMutation>;
export type SuggestUsernamesMutationOptions = Apollo.BaseMutationOptions<SuggestUsernamesMutation, SuggestUsernamesMutationVariables>;
export const CheckUsernameAvailabilityDocument = gql`
    mutation checkUsernameAvailability($input: CheckUsernameAvailabilityInput!) {
  checkUsernameAvailability(input: $input) {
    available
    reason
  }
}
    `;
export type CheckUsernameAvailabilityMutationFn = Apollo.MutationFunction<CheckUsernameAvailabilityMutation, CheckUsernameAvailabilityMutationVariables>;

/**
 * __useCheckUsernameAvailabilityMutation__
 *
 * To run a mutation, you first call `useCheckUsernameAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckUsernameAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkUsernameAvailabilityMutation, { data, loading, error }] = useCheckUsernameAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckUsernameAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CheckUsernameAvailabilityMutation, CheckUsernameAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckUsernameAvailabilityMutation, CheckUsernameAvailabilityMutationVariables>(CheckUsernameAvailabilityDocument, options);
      }
export type CheckUsernameAvailabilityMutationHookResult = ReturnType<typeof useCheckUsernameAvailabilityMutation>;
export type CheckUsernameAvailabilityMutationResult = Apollo.MutationResult<CheckUsernameAvailabilityMutation>;
export type CheckUsernameAvailabilityMutationOptions = Apollo.BaseMutationOptions<CheckUsernameAvailabilityMutation, CheckUsernameAvailabilityMutationVariables>;